import getBookingRequiredData from './getBookingRequiredData';
import getBookingSaga from './getBooking';
import getTicketCustomerDataChangesSaga from './getTicketCustomerDataChanges';
import updateDeliveriesSaga from './updateDeliveries';
import updateDeliverySaga from './updateDelivery';
import updateResaleSaga from './updateResale';

export const bookingSagas = [
  getBookingRequiredData,
  getBookingSaga,
  updateDeliverySaga,
  updateDeliveriesSaga,
  updateResaleSaga,
  getTicketCustomerDataChangesSaga,
];
